import React, { useEffect, useState } from 'react';
import {Link, useParams, useNavigate} from 'react-router-dom';
import { toast } from "react-toastify";
import {useForm} from "react-hook-form";
import AdminCashierAPI from "../../../apis/adminApi/AdminCashierAPI";
import FormContentLoader from "../../loaders/FormContentLoader";
import Field from "../../forms/Field";
import MyButton from "../../assets/MyButton";


const AdminEditCashIn = () => {

    const { formState } = useForm();
    const navigate = useNavigate();
    const { isSubmitting } = formState;
    const [loading, setLoading] = useState(true);
    let {cashInId} = useParams();
    const [accounts, setAccounts] = useState([]);
    const [sources, setSources] = useState([]);

    const [showLoader, setShowLoader] = useState(false);

    const [cashIn, setCashOut] = useState({
        description : "",
        currency : "",
        amount : "" ,
        created_at : "",
        motif : "",
        account : "",
        source : "",
        id: cashInId
    });

    const [editing, setEditing] = useState(false);

    const [errors, setErrors] = useState({
        description : "",
        currency : "",
        amount : "" ,
        created_at : "",
        motif : "",
        account : "",
        source : "",
    });


    //Recuperation d'une facture
    const fetchCashOneCashOut = async id => {
        try{
            const { currency,description, amount, created_at, motif, account, source, id } = await AdminCashierAPI.findOneCashIn(cashInId);
            setCashOut({ currency,description, amount, created_at, motif, account, source, id });
            setLoading(false);
        }catch(error){
            toast.error("Impossible de charger l'enregistrement !");
            navigate("/admin/cashier/cashIns");
        }
    };

    const getCashAccounts = async () => {
        try{
            const data =  await AdminCashierAPI.getCashAccounts();
            setAccounts(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes !");
        }
    };

    const getCashSources = async () => {
        try{
            const data =  await AdminCashierAPI.findCashAccounts();
            setSources(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes !");
        }
    };


    useEffect(() => {
        setEditing(true);
        fetchCashOneCashOut(cashInId);
        getCashAccounts();
        getCashSources();
    }, [cashInId]);


    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setCashOut({...cashIn, [name] : value})
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{
            setShowLoader(true);
            await AdminCashierAPI.storeCashIn(cashIn);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Sortie modifiée avec succès");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire de la modification !");
            }
        }
    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-7">
                    {loading && <FormContentLoader />}

                    {!loading && <form onSubmit={handleSubmit}>
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Modifier</h5>

                                <Field
                                    name="description"
                                    type="text"
                                    error={errors.description}
                                    value={cashIn.description}
                                    onChange={handleChange}
                                    label="Description"
                                />

                                <Field
                                    name="amount"
                                    type="number"
                                    error={errors.amount}
                                    value={cashIn.amount}
                                    onChange={handleChange}
                                    label="Montant"
                                    placeholder="000"
                                />

                                <label htmlFor="currency" className="form-label">Devise</label>
                                <select
                                    className={"form-select-sm form-control mb-2 " + ( errors.currency && "is-invalid")}
                                    //size={(buses.length)}
                                    name="currency"
                                    id="currency"
                                    value={cashIn.currency}
                                    onChange={handleChange}
                                >
                                    <option value="">Choisir...</option>
                                    <option value="FC">CDF</option>
                                    <option value="USD">USD</option>
                                </select>
                                {errors.currency && <div className="invalid-feedback mb-4">{errors.currency}</div>}

                                <label htmlFor="source" className="form-label">Source</label>
                                {!loading &&
                                    <select
                                        className={"form-select-sm form-control mb-2 " + ( errors.source && "is-invalid")}
                                        //size={(buses.length)}
                                        name="source"
                                        id="source"
                                        value={cashIn.source}
                                        onChange={handleChange}
                                    >

                                        <option value="">Choisir...</option>
                                        {sources && sources.map((source) => (
                                            <option key={source.id} value={source.name}>
                                                {source.name}</option>
                                        ))
                                        }
                                    </select>
                                }
                                {errors.account && <div className="invalid-feedback mb-4">{errors.account}</div>}

                                <label htmlFor="date" className="form-label">Date</label>
                                <input
                                    type="date"
                                    name="created_at"
                                    value={cashIn.created_at}
                                    onChange={handleChange}
                                    label="Date"
                                    className="form-control"
                                />
                                {errors.created_at && <div className="invalid-feedback mb-4">{errors.created_at}</div>}
                                <hr/>

                                <MyButton
                                    text="Modifier"
                                    onSubmit={handleSubmit}
                                    loading={showLoader}
                                    disabled={showLoader}
                                />
                                <Link to="/admin/cashier/rapport/cash/in" className="btn btn-info mx-2">Revenir</Link>
                            </div>
                        </div>
                    </form>
                    }
                </div>
            </div>
        </div>
    );
};

export default AdminEditCashIn;
